import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { API_UCF, useNetwork } from '../network-context';
import { AppThunkDispatch } from '../../store/reducers/root-reducer';
import getFormFieldsService from '../services/get-form-fields/get-form-fields.service';
import fetchFieldsAction from '../../store/async-actions/fetch-fields.action';
import { FetchedFieldsData, FormType } from '../../types/form.types';

type useGetFmerFormFieldsType = (() => Promise<void>) | undefined;
const useGetFormFields = (formType: FormType): useGetFmerFormFieldsType => {
  const { getClient } = useNetwork();
  const dispatch = useDispatch<AppThunkDispatch>();

  const fetchFunction = useMemo(
    () =>
      getClient && formType
        ? (): Promise<FetchedFieldsData> => {
            return getFormFieldsService(getClient(API_UCF), formType);
          }
        : undefined,
    [formType, getClient]
  );

  return useMemo(
    () =>
      fetchFunction
        ? (): Promise<void> => dispatch(fetchFieldsAction(fetchFunction))
        : undefined,
    [dispatch, fetchFunction]
  );
};

export default useGetFormFields;
